<template>
	<div class="main-container">
		<PickupEform />
	</div>
</template>
<script>
import PickupEform from "../components/PickupEform";
export default {
	name: "PickUp",
	components: {
		PickupEform,
	},
};
</script>
<style scoped>
.main-container {
	height: 100%;
	position: relative;
}
</style>
